export default "__VITE_ASSET__DPFdEEn9__"